exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loading-overlay[data-v-880e8ef6] {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 9999;\n    display: none;\n    align-items: center;\n    justify-content: center;\n}\n.loading-overlay .spinner-border[data-v-880e8ef6] {\n    width: 3rem;\n    height: 3rem;\n}\n", ""]);

// exports
